export const pluralize = (count: number, noun: string, suffix = 's') => {
  if (count === 0) {
    return `No ${noun}${suffix}`;
  }

  return `${count} ${noun}${count !== 1 ? suffix : ''}`;
};
